<template>
    <drawer-layout>
        <div class="report-container mx-7 mt-4">
            <indicators-header
                :type="type"
                @changeSearch="changeValueSearch"
                :title="this.indicatorBook.title"
            />
            <indicators-edition :search="search" :indicatorBookId="this.indicatorBook.uuid" :academicPeriodId="this.indicatorBook.academic_period_uuid" :canEdit="canEdit"/>
        </div>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import IndicatorsHeader from "@/Shared/Indicators/Editing/IndicatorsHeader";
import IndicatorsEdition from "@/Shared/Indicators/Editing/IndicatorsEdition";
// import {IndicatorsStore} from "@/Store/Indicators/IndicatorsStore";
// import {mapState, mapActions} from "pinia";

export default {
    name: "ManageEdit",
    components: {DrawerLayout, IndicatorsHeader, IndicatorsEdition},

    props: {
        type: {
            type: Object,
            default: [],
        },
        indicatorBookId: '',
        indicators: [],
        indicatorBook: [],
        canEdit: {
            type: Boolean,
            default: true,
        }
    },

    data () {
        return {
            search: '',
        }
    },

    // computed:{
    //     ...mapState(IndicatorsStore, ['indicatorBook']),
    //
    // },

    mounted() {
      //console.log(this.indicatorBook);
    },

    methods: {
        changeValueSearch(value) {
            this.search = value
        },

        // ...mapActions(IndicatorsStore, [
        //     'setCurrentIndicatorBook',
        // ]),
    },

    // created() {
    //     this.setCurrentIndicatorBook(this.indicatorBookId);
    // },
}
</script>

<style scoped>

</style>

